var map = {
	"./arcade.png": 78478,
	"./chat.png": 70604,
	"./events.png": 47073,
	"./fish.png": 94752,
	"./follow.png": 84617,
	"./gameRecords.png": 16248,
	"./hot.png": 6293,
	"./inbox.png": 21576,
	"./live.png": 82064,
	"./poker.png": 79131,
	"./promotions.png": 98288,
	"./records.png": 73154,
	"./redeem.png": 34574,
	"./security.png": 56996,
	"./settings.png": 71961,
	"./signUpBonus.png": 95345,
	"./slot.png": 52966,
	"./sports.png": 61731,
	"./task.png": 77581,
	"./vip.png": 75977
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15849;